import { UUID } from '../../../../types/shared/UUID';
import { useParams } from 'react-router-dom';
import { useListSigningAppointmentsQuery } from '../../../../API/order/signingAppointment/SigningAppointmentAPI';
import { useMemo } from 'react';
import { eSigningMethod } from 'types/signingAppointment/eSigningMethod';
import { CreateSigningAppointmentFormData } from './04_confirmationStep/convertToCreateSigningAppointmentRequest';
import {
  eCreateSigningAppointmentFormDataOwnerTypes,
  getFormDataOwnerType,
} from '../../../../types/order/consumer/eCreateSigningAppointmentFormDataOwnerTypes';

const defaultInitialWizardState = {
  ownerType: eCreateSigningAppointmentFormDataOwnerTypes.borrower,
  language: 'English',
  isSignatureSyncAppointment: false,
  isDigitalScheduling: false,
  isDigitalSchedulingDraft: false,
  signers: [],
  signingMethod: eSigningMethod.notaryOnly,
  signerWillProvideLocation: false,
  signerSelectsFromRange: false,
  dssAppointmentOptions: [],
};

export const useGenerateInitialWizardFormData = (correctionId?: UUID): CreateSigningAppointmentFormData => {
  const { orderId } = useParams<{ orderId: UUID }>();
  const { appointmentToCorrect } = useListSigningAppointmentsQuery(
    { orderId },
    {
      selectFromResult: ({ data }) => {
        const appointmentToCorrect = (data ?? []).find((appointment) => appointment.id === correctionId);
        return { appointmentToCorrect };
      },
    }
  );
  return useMemo(() => {
    if (correctionId && appointmentToCorrect) {
      const ownerType = getFormDataOwnerType(appointmentToCorrect.ownerType, appointmentToCorrect.isDigitalScheduling);
      return {
        ...appointmentToCorrect,
        address: undefined,
        appointmentDate: undefined,
        appointmentTime: undefined,
        availableEndDate: undefined,
        availableStartDate: undefined,
        isDateRange: false,
        correctionTriggeredById: appointmentToCorrect.id,
        correctionReasons: [],
        notary: undefined,
        notes: undefined,
        ownerType,
        rateCents: undefined,
      };
    }
    return { ...defaultInitialWizardState };
  }, [appointmentToCorrect, correctionId]);
};
